/**
 * 公共API
 */
import request from "@/utils/request";


// 导入文件失败提示
export function downloadErrorFile(params: object) {
  return request({
    url: "/common/errorFile",
    method: "get",
    responseType: "blob",
    params
  });
}

// 根据时间戳，找到这个时间戳对应的进度情况
export function getProgress(uuid: number) {
  return request({
    url: `/common/currentProgress?uuid=${uuid}`,
    method: "get",
  });
}
